var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChemical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#F3E5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 13.6667V18.6667C23.6666 18.9463 23.7368 19.2214 23.8709 19.4667L28.4626 27.8667C28.6014 28.1206 28.6719 28.4062 28.6669 28.6955C28.6619 28.9848 28.5816 29.2679 28.4341 29.5167C28.2865 29.7656 28.0767 29.9718 27.8252 30.115C27.5738 30.2582 27.2894 30.3335 27.0001 30.3334H17.0001C16.7107 30.3335 16.4263 30.2582 16.1749 30.115C15.9234 29.9718 15.7136 29.7656 15.5661 29.5167C15.4185 29.2679 15.3383 28.9848 15.3333 28.6955C15.3283 28.4062 15.3987 28.1206 15.5376 27.8667L20.1292 19.4667C20.2633 19.2214 20.3335 18.9463 20.3334 18.6667V13.6667",
    stroke: "#6A1B9A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3774 24.5H26.6224",
    stroke: "#6A1B9A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0833 13.6667H24.9166",
    stroke: "#6A1B9A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemical);
export default __webpack_public_path__ + "static/media/chemical.6b249a00c224b589890527d0967e842a.svg";
export { ForwardRef as ReactComponent };